// Token
export const hasToken = ({ token }) => !!token

// User
export const getUser = ({ user }) => user
export const getUserName = ({ user }) => user.first_name
export const getUserEmail = ({ user }) => user.email
export const getUserFullName = ({ user }) => user.first_name + ' ' + user.last_name
